import React, { useState, useEffect } from "react";
import CustomAlert from "../../../components/Alerts/CustomAlert";
import { addAlert, removeAlert } from "../../../Utils/helper";
import styles from "./AdminSettings.module.css";
import Button from "../../../components/Button/Button";
import LoadingOverlay from "../../../components/Loading/LoadingOverlay";
import { open_api_with_cookies } from "../../../Utils/network";

const AdminSettings = () => {
  const [alerts, setAlerts] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentIP, setCurrentIP] = useState("");

  useEffect(() => {
    detectCurrentIP();
  }, []);

  const detectCurrentIP = async () => {
    try {
      // Using a reliable IP detection service
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      setCurrentIP(data.ip);
    } catch (error) {
      console.error("Error detecting IP:", error);
      // Fallback to a different service
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        setCurrentIP(data.ip);
      } catch (fallbackError) {
        console.error("Fallback IP detection failed:", fallbackError);
        setCurrentIP("Unable to detect IP");
      }
    }
  };

  const handleAddAlert = (title, message, type, autoClose = false) => {
    addAlert(title, message, type, autoClose, setAlerts);
    setShowAlert(true);
  };

  const handleRemoveAlert = (id) => {
    removeAlert(id, setAlerts);
    if (alerts.length <= 1) setShowAlert(false);
  };

  const addCurrentIP = async () => {
    if (!currentIP || currentIP === "Unable to detect IP") {
      handleAddAlert(
        "Error",
        "Unable to detect your IP address. Please try again.",
        "error",
        true
      );
      return;
    }

    setIsLoading(true);
    try {
      const localData = {
        ip: currentIP,
      };

      const res = await open_api_with_cookies.post(
        "/core/waf/add-ip/",
        localData
      );

      if ([200, 201].includes(res.status)) {
        handleAddAlert(
          "Success",
          `IP address ${currentIP} has been added successfully! You now have access to the production server.`,
          "success",
          true
        );
        // Refresh the list of added IPs
      } else {
        handleAddAlert(
          "Failed",
          "Failed to add IP address. Please try again.",
          "error",
          true
        );
      }
    } catch (error) {
      console.error("Error adding IP address:", error);
      handleAddAlert(
        "Failed",
        "Failed to add IP address. Please try again later.",
        "error",
        true
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <div className={styles.mainContainer}>
        <div className={styles.settingsPage}>
          {showAlert &&
            alerts.map((alert) => (
              <CustomAlert
                key={alert.id}
                title={alert.title}
                message={alert.message}
                onClose={() => handleRemoveAlert(alert.id)}
                autoClose={alert.autoClose}
                type={alert.type}
              />
            ))}

          {/* IP Address Management Section */}
          <div className={styles.settingsSection}>
            <h3>IP Address Management</h3>
            <div className={styles.card}>
              <div className={styles.cardHeader}>
                <div className={styles.ipInfo}>
                  <h4>Add Your IP Address</h4>
                  <p className={styles.description}>
                    Click on the "Add IP" button which will automatically pick
                    your IPv4 address and gives you access to the production
                    server.
                  </p>
                </div>
              </div>

              <div className={styles.cardBody}>
                <div className={styles.currentIPSection}>
                  <div className={styles.ipDisplay}>
                    <span className={styles.ipLabel}>Your Current IP:</span>
                    <span className={styles.ipValue}>{currentIP}</span>
                  </div>
                  <Button
                    text="Add IP"
                    onClick={addCurrentIP}
                    style={{
                      backgroundColor: "#FF67A1",
                      fontSize: "14px",
                      padding: "10px 20px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminSettings;
